import { create } from 'zustand';

interface OfflineState {
  isOffline: boolean;
  setOffline: (status: boolean) => void;
}

export const useOfflineStore = create<OfflineState>((set) => ({
  isOffline: false,
  setOffline: (status) => set({ isOffline: status }),
}));